import React from "react";
import { ComplianceData } from "../DrainFieldInstallationInspectionForm.types";
import { DrainfieldProductMakeData, DrainfieldProductModelData } from "../DrainFieldInstallationInspectionForm.types";
import { OutletFilterData, AtuPbtData } from "../TankInstallationForm.types";

export const getComplianceNameById = (
    complianceData: ComplianceData[] | undefined,
    id: number | string | null | undefined
): string => {
    if (!complianceData || id === undefined || id === null || (id as any) === '') return '';
    const found = (complianceData as any[]).find(c => Number((c as any).id) === Number(id));
    return (found as any)?.name ?? String(id);
};

export const getDrainfieldProductMakeName = (
    makes: DrainfieldProductMakeData[] | undefined,
    id?: number | string | null
): string => {
    if (!makes || !id) return '';
    const found = (makes as any[]).find(x => Number((x as any).id) === Number(id));
    return (found as any)?.name ?? String(id);
};

export const getDrainfieldProductModelName = (
    models: DrainfieldProductModelData[] | undefined,
    id?: number | string | null
): string => {
    if (!models || !id) return '';
    const found = (models as any[]).find(x => Number((x as any).id) === Number(id));
    return (found as any)?.name ?? String(id);
};

export const getOutletFilterName = (
    filters: OutletFilterData[] | undefined,
    id?: number | string | null
): string => {
    if (!filters || !id) return '';
    const found = (filters as any[]).find(x => Number((x as any).id) === Number(id));
    return (found as any)?.name ?? String(id);
};

export const getAtuPbtName = (
    list: AtuPbtData[] | undefined,
    id?: number | string | null
): string => {
    if (!list || !id) return '';
    const found = (list as any[]).find(x => Number((x as any).id) === Number(id));
    return (found as any)?.name ?? String(id);
};

export const renderYesNoBadge = (value?: boolean | null) => {
    if (value === undefined || value === null) return null;
    return (
        <span className={`fw-bold ${value ? "text-success" : "text-muted"}`}>
            {value ? "Yes" : "No"}
        </span>
    );
};

export const renderDecisionBadge = (value?: boolean | null) => {
    if (value === undefined || value === null) return null;
    return (
        <span className={`fw-bold ${value ? "text-success" : "text-danger"}`}>
            {value ? "Approved" : "Disapproved"}
        </span>
    );
};

export const getLegendValue = (
    legends: any[] | undefined,
    id?: number | string | null
): string => {
    if (!legends || !id) return '';
    const found = (legends as any[]).find(x => Number((x as any).id) === Number(id));
    return (found as any)?.name ?? String(id);
};

export const getTankMaterialName = (
    materials: any[] | undefined,
    id?: number | string | null
): string => {
    if (!materials || !id) return '';
    const found = (materials as any[]).find(x => Number((x as any).id) === Number(id));
    return (found as any)?.name ?? String(id);
};



